export type Resurs = {
    id: number;
    namn: string;
    totalt_antal: number;
    ordning: number;
    typ: string | null;
    tid_fore_salstid_start: number | null;
    tid_efter_salstid_slut: number | null;
};

export const convertResursData = ({ resurs }: { resurs: Resurs }) => {
    if (!resurs) {
        return null;
    }

    return {
        value: resurs.id,
        label: `${resurs.namn} ${resurs.totalt_antal >= 1 ? "(totalt " + resurs.totalt_antal + " st)" : "(inaktiv)"}`,
    };
};

export const getResursWithStatus = (resurs: Resurs) => {
    if (resurs.totalt_antal < 1) {
        return `${resurs.namn} (inaktiv)`;
    } else {
        return resurs.namn;
    }
};
